import { render, staticRenderFns } from "./LiveOrderStates.vue?vue&type=template&id=187338a9&"
import script from "./LiveOrderStates.vue?vue&type=script&lang=js&"
export * from "./LiveOrderStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187338a9')) {
      api.createRecord('187338a9', component.options)
    } else {
      api.reload('187338a9', component.options)
    }
    module.hot.accept("./LiveOrderStates.vue?vue&type=template&id=187338a9&", function () {
      api.rerender('187338a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/LiveOrderStates.vue"
export default component.exports